import { UserModel } from '../../models';

export enum ActionType {
  SIGN_IN_START = '[auth] sign in start',
  SIGN_IN_SUCCESS = '[auth] sign in success',
  SIGN_OUT_START = '[auth] sign out start',
  SIGN_OUT_SUCCESS = '[auth] sign out success',
  RECOVER_SESSION_START = '[auth] recover session start',
  RECOVER_SESSION_DONE = '[auth] recover session success',
  FETCH_USER_PERMISSIONS_START = '[auth] fetch admin permission start',
  FETCH_USER_PERMISSIONS_SUCCESS = '[auth] fetch user permissions success',
  SET_CLIENT_ID = '[auth] set client id',
  SET_ORIGINAL_COMPANY_ID = '[auth] set original client id',
  SET_USER_NAME = '[auth] set user name',
  INITIATE_AUTH = '[auth] initiate auth',
  RESPOND_TO_CHALLENGE_AUTH = '[auth] respond to challenge',
}

export const actions = {
  signInStart: (username: string, password: string) => ({ type: ActionType.SIGN_IN_START, payload: { username, password } }),
  signInSuccess: (session: UserModel.IUser) => ({ type: ActionType.SIGN_IN_SUCCESS, payload: { session } }),
  signOutStart: () => ({ type: ActionType.SIGN_OUT_START, payload: {} }),
  signOutSuccess: () => ({ type: ActionType.SIGN_OUT_SUCCESS, payload: {} }),
  recoverSessionStart: () => ({ type: ActionType.RECOVER_SESSION_START, payload: {} }),
  recoverSessionDone: () => ({ type: ActionType.RECOVER_SESSION_DONE, payload: {} }),
  fetchUserPermissionsStart: (id: string) => ({ type: ActionType.FETCH_USER_PERMISSIONS_START, payload: { id } }),
  fetchUserPermissionsSuccess: (perimissions: any, isProjectAdmin: boolean) => ({
    type: ActionType.FETCH_USER_PERMISSIONS_SUCCESS,
    payload: { perimissions, isProjectAdmin },
  }),
  setClientId: (value: string) => ({ type: ActionType.SET_CLIENT_ID, payload: { value } }),
  setOriginalCompanyId: (value: string) => ({ type: ActionType.SET_ORIGINAL_COMPANY_ID, payload: { value } }),
  setUserName: (value: string) => ({ type: ActionType.SET_USER_NAME, payload: { value } }),
  initiateAuth: (userName: string, clientId: string, selectedCompany: string) => ({
    type: ActionType.INITIATE_AUTH,
    payload: { userName, clientId, selectedCompany },
  }),
  respondToChallenge: (userName: string, clientId: string, selectedCompany: string, authResponse: any) => ({
    type: ActionType.RESPOND_TO_CHALLENGE_AUTH,
    payload: { userName, clientId, selectedCompany, authResponse },
  }),
};
